// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__22dam"};